import { ApiRoutes } from "consts/enpoints/api";
import { getFileExtension } from "util/support";
import { downloadFileApi, fetchApi } from "infrastructure/api";
import type { KYCEntity, KYCSettings, ManualBulkKYCsImportHistory } from "./types";

export const getManualBulkKYCsImportHistory = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetManualBulkKYCsImportHistory}${queryString}`);

export const getKYCSettings = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetKYCSettings}${queryString}`);

export const updateOrCreateKYCSettings = (body: Partial<KYCSettings>) =>
    fetchApi(ApiRoutes.PostKYCSettings(body.merchantId), {
        method: 'PUT',
        body
    });

export const getKYCEntities = (queryString = '') =>
    fetchApi(`${ApiRoutes.GetKycs}${queryString}`);

export const createKYCEntity = (body: Pick<
    KYCEntity,
    | 'consumerId'
    | 'kycTypeId'
    | 'fileKey'
    | 'reason'
    | 'countryIso2'
>) =>
    fetchApi(ApiRoutes.PostKycs, {
        method: 'POST',
        body
    });

export const deleteKYCEntity = (pki: string) =>
    fetchApi(ApiRoutes.DeleteKYCs(pki), {
        method: 'DELETE'
    });

export const downloadKYCFile = (fileKey: string, fileName: string) =>
    downloadFileApi(ApiRoutes.GetFile(fileKey), {
        headers: {
            Accept: `application/${getFileExtension(fileKey)}`,
        },
        fileName
    });

export const createManualBulkKYCsImportHistory = (body: Pick<
    ManualBulkKYCsImportHistory,
    | 'fileKey'
    | 'kycFileKey'
    | 'merchantId'
    | 'kycTypeIds'
    | 'MOR'
>) =>
    fetchApi(ApiRoutes.PostManualBulkKYCsImportHistory, {
        method: 'POST',
        body
    });
